import { useAbTestFeatureVariant } from '@sprd/sprd-abtest-next/client';

/**
 * Client-side gate for the "promotion-banner" A/B test (DEV-231811):
 * disables the promo announcement bar + popup for the `variant` value.
 * Control (`control`, also the fallback) keeps both shown, as today.
 */
export const useIsPromotionBannerDisabled = () =>
  useAbTestFeatureVariant<'control' | 'variant'>('promotion-banner', 'control') === 'variant';
